import { render, staticRenderFns } from "./articulos-lista-mini.vue?vue&type=template&id=5c03992d&scoped=true&"
import script from "./articulos-lista-mini.vue?vue&type=script&lang=ts&"
export * from "./articulos-lista-mini.vue?vue&type=script&lang=ts&"
import style0 from "./articulos-lista-mini.vue?vue&type=style&index=0&id=5c03992d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c03992d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
installComponents(component, {VList,VListItemGroup})
